import axios from "axios";
import { getToken } from "../Apimanager/Networking";
import { store } from "../redux/store";
import { ShowAlert } from "../common/alert";
import { getOnboardingBaseUrl, handleApiError } from "./apiUtils";

const baseURL = getOnboardingBaseUrl();

export const registerProvider = async ({ email, name, referralCode, signUpMethod }) => {
   try {
      const response = await axios.post(baseURL + "/eu/providers", {
         email,
         name,
         referralCode,
         signUpMethod,
      });
      return response.data;
   } catch (error) {
      ShowAlert(error?.data?.message || "Registration failed", "error");
      throw error;
   }
};

export const updateProvider = async ({ specialities }) => {
   const userId = store.getState().auth?.userCredentials?.user?.id;
   const token = await getToken();

   try {
      const response = await axios.patch(
         baseURL + "/eu/providers",
         { userId, specialities },
         {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }
      );
      return { response: response.data, userData: store.getState().auth.userCredentials };
   } catch (error) {
      handleApiError(error, "Provider update failed");
   }
};

export const loginProvider = async ({ email, signInMethod }) => {
   try {
      const response = await axios.post(baseURL + "/login", {
         email,
         signInMethod,
      });
      return response.data;
   } catch (error) {
      handleApiError(error, "Login failed");
   }
};

export const checkLogin = async ({ email, signInMethod, unsetLoader }) => {
   try {
      const response = await axios.post(baseURL + "/eu/login", {
         email,
         signInMethod,
      });
      return response.data;
   } catch (error) {
      ShowAlert(error?.data?.message || "Login check failed", "error");
      unsetLoader?.();
      throw error;
   }
};

export const verifyOTP = async ({ key, otp }) => {
   try {
      const response = await axios.post(baseURL + "/eu/login/verify", {
         key,
         otp,
         authMethod: "otp",
      });
      return response.data;
   } catch (error) {
      handleApiError(error, "OTP verification failed");
   }
};

export const resendOTPVerify = async ({ key }) => {
   try {
      const response = await axios.post(baseURL + "/login/verify", {
         key,
         authMethod: "resendOtp",
      });
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const verifyPassword = async ({ key, password, authMethod }) => {
   try {
      const response = await axios.post(baseURL + "/eu/login/verify", {
         key,
         password,
         authMethod,
      });
      return response.data;
   } catch (error) {
      handleApiError(error, "Password verification failed");
   }
};

export const verifyToken = async ({ cognitoToken }) => {
   try {
      const response = await axios.post(baseURL + "/login/verify", {
         firebaseToken: cognitoToken,
         authMethod: "token",
      });
      return response.data;
   } catch (error) {
      handleApiError(error, "Token verification failed");
   }
};

export const refreshAuthToken = async ({ refreshToken, email }) => {
   try {
      const response = await axios.post(baseURL + "/eu/token/refresh", {
         refreshToken,
         email
      });
      return response.data;
   } catch (error) {
      handleApiError(error, "Session refresh failed");
   }
};

export const forgotPassword = async ({ email }) => {
   try {
      const response = await axios.post(baseURL + "/auth/forgot-password", {
         email,
      });
      return response.data;
   } catch (error) {
      handleApiError(error, "Password reset failed");
   }
};

export const authenticateProvider = async ({ token, signInMethod = "cognito" }) => {
   try {
      const response = await axios.post(baseURL + "/login", {
         token,
         signInMethod,
      });
      return response.data;
   } catch (error) {
      throw error;
   }
};
export const googleLoginCognito = () => {
   window.location.replace(baseURL + "/eu/auth/google")
};